import request from "../../../helpers/request";

export const excluirAlerta = async (id: number, fisico: boolean = false) => {
  const url = `${process.env.REACT_APP_API}/Alerta/${id}?fisico=${fisico}`;
  const result = await request({
    url,
    method: "DELETE",
  });
  return result.data;
};
